<div id="chart" *ngIf="hasRenderableOptions">
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [yaxis]="chartOptions.yaxis"
    [plotOptions]="chartOptions.plotOptions"
    [dataLabels]="chartOptions.dataLabels"
    [grid]="chartOptions.grid"
    [stroke]="chartOptions.stroke"
    [title]="chartOptions.title"
    [labels]="chartOptions.labels"
  ></apx-chart>
</div>
